import { TransformInt } from '../../../decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

/**
 * Create status tracking priority DTO
 */
export class CreateStatusTrackingPriorityDto {
	subject!: AppSubjectEnum;
	status!: string;
	@TransformInt()
	priority!: number;
}
